import React, { Component } from "react";
import {ToggleButton, ToggleButtonGroup} from "react-bootstrap";

class ChartSelector extends Component {
    constructor(props) {
        super(props);
        this.symbolOptions = props.symbolOptions;
        this.parentChange = props.onChange;

        this.onChangeValue = this.onChangeValue.bind(this);
        this.options =[]
        for(let i = 0; i < this.symbolOptions.length; i++){
            this.options.push(<ToggleButton
                key={i}
                value={i}
            >{this.symbolOptions[i].title}</ToggleButton>);
        }
    }

    onChangeValue(index) {
        this.parentChange(index);
    }

    render() {
        return (
            <ToggleButtonGroup type="radio" name="chartSelector" defaultValue={0} onChange={this.onChangeValue}>
                {this.options}
            </ToggleButtonGroup>
        );
    }
}

export {ChartSelector};